var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000006728"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Style-01"
  }, /*#__PURE__*/React.createElement("g", {
    id: 36
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M83.8859 140.497C115.429 140.497 141.01 115.108 141.01 83.7575C141.01 52.4065 115.429 27.018 83.8859 27.018C52.3426 27.018 26.7617 52.4065 26.7617 83.7575C26.7617 115.108 52.3426 140.497 83.8859 140.497Z",
    fill: "#202531"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M127.642 76.3525V111.069C127.642 118.282 121.776 124.148 114.467 124.148H53.4964C46.2838 124.148 40.4175 118.378 40.3213 111.165C40.3213 111.069 40.3213 111.069 40.3213 110.973V76.3525C40.3213 76.2563 40.3213 76.2563 40.3213 76.1601C40.3213 75.9678 40.3213 75.7755 40.4175 75.5831C40.5136 75.2946 40.6098 75.1023 40.706 74.8138L57.0546 43.559C57.6317 42.3088 58.8819 41.6356 60.2282 41.6356H107.639C108.986 41.6356 110.14 42.3088 110.813 43.559L127.162 74.8138C127.258 75.0061 127.354 75.2946 127.45 75.5831C127.642 75.7755 127.642 76.064 127.642 76.3525Z",
    fill: "url(#paint0_linear_1685_26228)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    filter: "url(#filter0_d_1685_26228)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.642 76.3525V114.628C127.642 119.917 123.411 124.148 118.026 124.148H49.9382C44.6489 124.148 40.3213 119.917 40.3213 114.628V76.1601C40.3213 75.9678 40.3213 75.7755 40.4175 75.5831H62.3439C65.6137 75.5831 68.3064 78.1797 68.3064 81.5456C68.3064 83.1804 68.9796 84.7191 70.0374 85.777C71.1915 86.931 72.5378 87.508 74.2689 87.508H93.7911C97.0608 87.508 99.7536 84.9115 99.7536 81.5456C99.7536 79.9107 100.427 78.372 101.485 77.3142C102.639 76.1601 103.985 75.5831 105.62 75.5831H127.45C127.642 75.7755 127.642 76.064 127.642 76.3525Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M127.642 76.3525V114.628C127.642 119.917 123.411 124.148 118.026 124.148H49.9382C44.6489 124.148 40.3213 119.917 40.3213 114.628V76.1601C40.3213 75.9678 40.3213 75.7755 40.4175 75.5831H62.3439C65.6137 75.5831 68.3064 78.1797 68.3064 81.5456C68.3064 83.1804 68.9796 84.7191 70.0374 85.777C71.1915 86.931 72.5378 87.508 74.2689 87.508H93.7911C97.0608 87.508 99.7536 84.9115 99.7536 81.5456C99.7536 79.9107 100.427 78.372 101.485 77.3142C102.639 76.1601 103.985 75.5831 105.62 75.5831H127.45C127.642 75.7755 127.642 76.064 127.642 76.3525Z",
    fill: "url(#paint1_linear_1685_26228)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M139.55 56.638C141.728 56.638 143.493 54.8685 143.493 52.6951C143.493 50.5217 141.728 48.7522 139.55 48.7522C137.372 48.7522 135.607 50.5217 135.607 52.6951C135.607 54.8685 137.372 56.638 139.55 56.638Z",
    fill: "#404756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    d: "M135.608 43.8477C137.095 43.8477 138.3 42.6455 138.3 41.1549C138.3 39.6643 137.095 38.4622 135.608 38.4622C134.12 38.4622 132.915 39.6643 132.915 41.1549C132.915 42.6455 134.12 43.8477 135.608 43.8477Z",
    fill: "#404756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    d: "M26.5526 52.6951C28.0394 52.6951 29.2453 51.493 29.2453 50.0024C29.2453 48.5118 28.0394 47.3097 26.5526 47.3097C25.0649 47.3097 23.8599 48.5118 23.8599 50.0024C23.8599 51.493 25.0649 52.6951 26.5526 52.6951Z",
    fill: "#404756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    d: "M20.4939 111.935C23.2559 111.935 25.4947 109.694 25.4947 106.934C25.4947 104.174 23.2559 101.933 20.4939 101.933C17.732 101.933 15.4932 104.174 15.4932 106.934C15.4932 109.694 17.732 111.935 20.4939 111.935Z",
    fill: "#404756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    d: "M108.043 30.0665C109.298 43.7705 109.925 46.9056 107.084 59.3113C106.159 62.0714 105.236 65.0911 103.255 67.1972C100.484 70.4765 95.4664 71.919 91.3744 70.8708C87.1498 69.8226 83.7175 66.1393 82.9251 61.6771C82.2653 58.9171 83.1895 55.6377 85.5659 53.9259C88.0739 52.3487 91.638 52.743 93.7508 54.7145C96.1271 56.6859 97.0513 59.7056 96.9186 62.6003C96.7868 65.4854 95.7309 68.38 94.2787 70.8708C90.9955 77.0064 89.6444 76.9871 82.9251 87.0656",
    stroke: "#ABB5CC",
    strokeWidth: 1.92337,
    strokeDasharray: "3.85 3.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    d: "M115.404 24.9599C114.902 26.7967 112.895 27.4603 110.888 26.2967C108.713 25.2965 107.208 24.4599 107.542 22.7961C108.044 21.1324 110.051 20.9689 112.393 20.8054C115.236 20.4689 115.738 23.1327 115.404 24.9599Z",
    fill: "#DAE2EB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    d: "M99.1787 26.6237C100.015 28.1239 102.357 29.124 104.029 27.6238C105.869 25.9601 107.374 24.7965 106.538 23.1327C105.702 21.6325 104.364 22.1326 101.52 22.4692C99.1787 22.9693 98.1747 24.9599 99.1787 26.6237Z",
    fill: "#DAE2EB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    d: "M106.539 20.469C107.709 20.3055 108.88 20.9691 109.215 21.9692C109.382 22.2962 109.55 22.7963 109.55 23.1328C109.884 25.4601 109.048 27.4604 107.709 27.6239C106.204 27.9605 104.699 26.2968 104.532 24.133C104.532 23.4598 104.532 23.1328 104.532 22.6328C104.699 21.4691 105.367 20.6325 106.539 20.469Z",
    fill: "#657289"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    d: "M73.0098 101.318C74.2283 101.318 75.2159 100.327 75.2159 99.1059C75.2159 97.8942 74.2283 96.9036 73.0098 96.9036C71.7914 96.9036 70.8037 97.8942 70.8037 99.1059C70.8037 100.327 71.7914 101.318 73.0098 101.318Z",
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    d: "M94.9546 101.318C96.1731 101.318 97.1608 100.327 97.1608 99.1059C97.1608 97.8942 96.1731 96.9036 94.9546 96.9036C93.7362 96.9036 92.7485 97.8942 92.7485 99.1059C92.7485 100.327 93.7362 101.318 94.9546 101.318Z",
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    d: "M87.5603 115.81H80.6429C79.5697 115.81 78.6753 114.916 78.6753 113.839C78.6753 112.762 79.5697 111.867 80.6429 111.867H87.5007C88.5739 111.867 89.4683 112.762 89.4683 113.839C89.5279 114.916 88.6336 115.81 87.5603 115.81Z",
    fill: "#D5DDEA"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1685_26228",
    x: 19.1642,
    y: 65.0046,
    width: 129.635,
    height: 90.8793,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10.5785
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.5785
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.396078 0 0 0 0 0.478431 0 0 0 0 0.576471 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1685_26228"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1685_26228",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1685_26228",
    x1: 83.9819,
    y1: 41.6356,
    x2: 83.9819,
    y2: 124.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343D4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1685_26228",
    x1: 83.9819,
    y1: 75.5831,
    x2: 83.9819,
    y2: 124.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65748E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F5C72"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no-data.e54d25fb0fe08702ce324196ce215589.svg";
export { ForwardRef as ReactComponent };